import React from 'react';
import { RectShape } from 'react-placeholder/lib/placeholders';
import classNames from 'clsx';

import { InputPlaceholderProps } from './InputPlaceholder.interfaces';
import { useStyles } from './InputPlaceholder.styles';

const InputPlaceholder: React.FunctionComponent<InputPlaceholderProps> = ({
  width = 'md',
}) => {
  const classes = useStyles();
  const widthClass = classes[width];

  return (
    <div
      className={classNames(classes.root, 'show-loading-animation', widthClass)}
      data-cy="show-loading-animation"
    >
      <RectShape className={classes.placeholderRectShape} />
    </div>
  );
};

export default InputPlaceholder;
